export const ctmApp = require('./packages/ctm-vertical-car')
